<template>
  <div v-if="!popupLoaded">
    <svg
      class="m-auto absolute animate-spin w-[76px] fill-white"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 95.979 96"
      style="top: calc(50% - 38px); left: calc(50% - 38px)"
    >
      <path
        d="M2,50A48,48,0,0,1,16.07,16.07L5.61,5.61A2.11,2.11,0,0,1,7.1,2H35a3,3,0,0,1,3,3V32.9a2.11,2.11,0,0,1-3.61,1.49l-9.84-9.84A36,36,0,0,0,50,86V98A48.05,48.05,0,0,1,2,50ZM50,2V14A36,36,0,0,1,75.45,75.45l-9.74-9.74A2.17,2.17,0,0,0,62,67.25V95a3,3,0,0,0,3,3H92.75a2.17,2.17,0,0,0,1.54-3.71L83.93,83.93A48,48,0,0,0,50,2Z"
        transform="translate(-2 -2)"
      />
    </svg>
  </div>

  <div class="h-screen w-screen flex overflow-hidden">
    <div class="flex h-screen w-screen">
      <div
        v-if="!FullScreenMap"
        class="h-screen w-full flex ease-out duration-200"
        :class="AppClass"
      >
        <div
          class="w-full h-full py-5 pr-5 pl-5 overflow-auto relative flex-flex-col"
        >
          <Site v-if="$root.global.site && $root.mainMapReady" />
        </div>
      </div>

      <div class="w-full h-full relative sous-carte">
        <div class="absolute left-0 h-screen w-[16px] min-w-[16px] flex z-10">
          <div
            class="my-auto max-h-[80px] bg-flyingeye h-full flex p-[4px] cursor-pointer"
            style="border-radius: 0 4px 4px 0"
            @click="main_active = !main_active"
          >
            <SVG
              name="doubleChevron"
              :css="
                'm-auto w-[10px] fill-current ' +
                (!main_active ? 'rotate-180' : '')
              "
            ></SVG>
          </div>
        </div>

        <!-- POPUP -->

        <div
          id="flight_0"
          class="relative bg-black"
          :class="{
            map_only: $root.isMilestonePlugin,
            MAP_ON_FRONT: MAP_EMPLACEMENT == '#FRONT',
          }"
        >
          <!-- VIDEO -->
          <div class="w-full h-full relative">
            <svg
              class="m-auto absolute animate-spin w-[76px] fill-g0"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 95.979 96"
              style="top: calc(50% - 38px); left: calc(50% - 38px)"
            >
              <path
                d="M2,50A48,48,0,0,1,16.07,16.07L5.61,5.61A2.11,2.11,0,0,1,7.1,2H35a3,3,0,0,1,3,3V32.9a2.11,2.11,0,0,1-3.61,1.49l-9.84-9.84A36,36,0,0,0,50,86V98A48.05,48.05,0,0,1,2,50ZM50,2V14A36,36,0,0,1,75.45,75.45l-9.74-9.74A2.17,2.17,0,0,0,62,67.25V95a3,3,0,0,0,3,3H92.75a2.17,2.17,0,0,0,1.54-3.71L83.93,83.93A48,48,0,0,0,50,2Z"
                transform="translate(-2 -2)"
              />
            </svg>
            <div id="FRONT" class="w-full h-full relative"></div>
            <template
              v-if="video_selected != false && !$root.isMilestonePlugin"
            >
              <div class="w-full h-full absolute z-0 top-0 left-0">
                <Camera
                  :config="device.config"
                  :video="video_selected"
                  v-if="device?.config?.isDock && !video_selected?.cameradock"
                />
              </div>
            </template>
          </div>
          <!-- OVERLAY -->
          <div
            id="OVERLAY"
            :class="{ active: $root?.global?.interfacePopupHide == true }"
            class="absolute top-0 left-0 w-full h-full pointer-events-none"
          >
            <div class="flex flex-col w-full h-full relative">
              <!-- TOP -->
              <div id="TOP" class="w-full flex justify-between relative">
                <POPUP_TOP :device="device" />
              </div>

              <!-- MID -->
              <div class="w-full flex justify-between h-full"></div>

              <!-- BOTTOM -->
              <div class="overlay_bottom">
                <!-- OVERLAY_VIDEO -->
                <div
                  id="OVERLAY_VIDEO"
                  class="flex pointer-events-all min-w-[220px] max-h-[140px]"
                ></div>
                <!-- BOTTOM CENTRE -->
                <POPUP_BOTTOM_CENTER
                  v-if="device?.config"
                  :device="device"
                  :VIDEO_EMPLACEMENT="VIDEO_EMPLACEMENT"
                />

                <!-- MAP -->
                <div
                  class="h-full w-auto aspect-video pointer-events-all max-h-[140px]"
                  id="OVERLAY_MAP"
                ></div>
              </div>
            </div>
          </div>

          <!-- MENU -->
          <div
            id="MENU"
            :class="{ active: $root?.global?.menuPopupOpen === true }"
          >
            <div
              class="my-auto max-h-[80px] bg-flyingeye h-full flex p-[4px] cursor-pointer pointer-events-all"
              style="border-radius: 4px 0 0 4px"
              @click="$root.global.menuPopupOpen = false"
            >
              <svg
                width="10"
                class="m-auto"
                viewBox="0 0 120 100"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.66 100L61.66 50L11.66 0L0 11.67L38.33 50L0 88.33L11.66 100Z"
                  fill="#fff"
                />
                <path
                  d="M69.66 100L119.66 50L69.66 0L58 11.67L96.33 50L58 88.33L69.66 100Z"
                  fill="#fff"
                />
              </svg>
            </div>
            <POPUP_MENU
              :device="device"
              @forceAffichage="
                (type) => {
                  forceAffichage(type);
                }
              "
            />
          </div>
        </div>

        <!-- END POPUP -->
      </div>
    </div>
  </div>

  <HMS v-if="device?.config" :config="device.config" />

  <Teleport :to="MAP_EMPLACEMENT">
    <div class="w-full h-full relative">
      <div id="mainMap" class="relative w-full h-full"></div>
      <div class="switch" @click="SwitchFront(true)">
        <SVG name="openPopup" css="w-[20px] fill-white"></SVG>
      </div>
    </div>
  </Teleport>

  <template v-for="video in videos" :key="video.id">
    <Teleport :to="VIDEO_EMPLACEMENT[video.dvv_id]">
      <div class="w-full h-full relative">
        <Video :config="device.config" :video="video" />
        <div class="reload" v-if="!video.publish" @click="videoOn(video)">
          <svg
            class="fill-white w-full"
            :class="{ 'animate-spin': video.relaod }"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 95.979 96"
          >
            <path
              d="M2,50A48,48,0,0,1,16.07,16.07L5.61,5.61A2.11,2.11,0,0,1,7.1,2H35a3,3,0,0,1,3,3V32.9a2.11,2.11,0,0,1-3.61,1.49l-9.84-9.84A36,36,0,0,0,50,86V98A48.05,48.05,0,0,1,2,50ZM50,2V14A36,36,0,0,1,75.45,75.45l-9.74-9.74A2.17,2.17,0,0,0,62,67.25V95a3,3,0,0,0,3,3H92.75a2.17,2.17,0,0,0,1.54-3.71L83.93,83.93A48,48,0,0,0,50,2Z"
              transform="translate(-2 -2)"
            />
          </svg>
        </div>
        <div class="switch" @click="SwitchFront(false, video.dvv_id)">
          <SVG name="openPopup" css="w-[20px] fill-white"></SVG>
        </div>
      </div>
    </Teleport>
  </template>

  <template v-if="device?.loaded === true">
    <Device_Info_Both :config="device.config" />
  </template>
</template>

<script>
import { ref } from "vue";
import { toast } from "vue3-toastify";
import { CesiumPosition } from "@/utils/constant/settings_constantes";
import SVG from "@/partials/SVG.vue";
import API from "@/utils/API";
import MapVue from "@/partials/Map/Map.vue";
// ---
import POPUP_TOP from "@/app/popup/partial/POPUP_TOP.vue";
import POPUP_MENU from "@/app/popup/partial/POPUP_MENU.vue";
import POPUP_BOTTOM_CENTER from "@/app/popup/partial/POPUP_BOTTOM_CENTER.vue";
// ---
import Video from "@/app/popup/partial/Video.vue";
import Site from "@/app/popup/partial/Site/Site_Popup.vue";
import Device_Info_Both from "@/partials/Device/Info/Device_Info_Both.vue";
import HMS from "@/partials/Device/Template/HMS/HMS.vue";
import Camera from "@/app/popup/partial/Camera.vue";

export default {
  name: "App_Popup",
  components: {
    SVG,
    POPUP_TOP,
    POPUP_MENU,
    POPUP_BOTTOM_CENTER,
    MapVue,
    Video,
    Site,
    Device_Info_Both,
    Camera,
    HMS,
  },
  setup() {
    return {
      main_active: ref(false),
      popupLoaded: ref(false),
      device: ref(null),
      videos: ref([]),
      video_selected: ref({}),
      toastIdDroneOn: ref(null),
      MAP_EMPLACEMENT: ref("#OVERLAY_MAP"),
      VIDEO_EMPLACEMENT: ref({}),
    };
  },

  beforeMount() {
    this.$root.global.menuPopupOpen = false;
    this.$root.global.interfacePopupHide = false;
    this.$root.toastConfig.position = toast.POSITION.TOP_LEFT;
    this.$root.toastMsgReplie.position = toast.POSITION.TOP_LEFT;
  },

  methods: {
    async initAPP() {
      this.$root.Map_ShowOverlayElement = $root.isMilestonePlugin
        ? true
        : false;
      this.$root.positionMap = CesiumPosition.Main;
      this.$root.mainMapReady = true;

      this.device = API.getFirstData(
        await API.get("device", {
          DevId: this.$route.params.dev_id,
        })
      );

      if (this.device?.dev_id == undefined) {
        this.$router.push({ name: "404" });
      }

      if (this.device?.sit_id != undefined) {
        this.initSite(this.device.sit_id);
      }

      this.startWaitDeviceOnline();

      if ($root.isMilestonePlugin) {
        setTimeout(() => {
          this.MAP_EMPLACEMENT = "#FRONT";
        }, 1000);
      }
    },

    switchMap() {
      this.$root.Map_ShowOverlayElement = true;
      this.MAP_EMPLACEMENT = "#FRONT";

      let keys = Object.keys(this.VIDEO_EMPLACEMENT);

      keys.forEach((key) => {
        this.VIDEO_EMPLACEMENT[key] = "#OVERLAY_VIDEO";
      });

      // this.$forceUpdate();
    },

    startWaitDeviceOnline() {
      setTimeout(() => {
        this.$root.watchVariable.add(
          this.$root.devices,
          "online",
          (online, old, watcherID) => {
            if (
              online[this.device.dev_id] != undefined &&
              this.$root.devices.firstParseLoaded
            ) {
              this.$root.watchVariable.remove(watcherID);
              this.$root.pageLoad = false;
              this.popupLoaded = true;
              this.initDevice();
            }
          }
        );
      }, 2000);
    },

    initDevice() {
      this.$root.devices.online[this.device.dev_id] = {
        ...this.device,
        ...this.$root.devices.online[this.device.dev_id],
      };

      this.device = this.$root.devices.online[this.device.dev_id];

      if (
        this.$root.device_dock_type.hasOwnProperty(
          this.device.config.deviceFamilly.this_det_id
        )
      ) {
        let droneActive =
          this.device.config?.dock?.id != undefined &&
          this.device.config?.drone?.status?.mode_code !== undefined &&
          this.device.config.drone.status.mode_code != 14;

        if (!droneActive) {
          this.toastIdDroneOn = toast.loading(
            this.$e("Activation du drone"),
            this.$root.toastConfig
          );

          this.drcmodeenter();
          /*
          this.$root.confirm_open({
            message: this.$e("Voulez-vous activer le drone ?"),
            true: async () => {

            },
            false: () => {
              this.openFluxVideo(true);
            },
          });
          */
        } else {
          this.initVerifDrcModeAllwaysActive();
          this.openFluxVideo(false);
        }
      } else {
        this.openFluxVideo(false);
      }

      let controler =
        this.device?.config?.dock?.id != undefined
          ? `#${this.device.config.dock.id} - ${this.device.config.dock.name}`
          : `#${this.device.config.rcPlus.id} - ${this.device.config.rcPlus.name}`;
      this.$root.set_title(controler);

      this.device.config.full_screen_active = true;
    },

    drcmodeenter() {
      API.put("drcmodeenter", {
        DevId: this.device.dev_id,
      });

      this.$root.watchVariable.add(
        this.device.config,
        "drone",
        (drone, oldValue, watcherID) => {
          if (
            drone?.status?.mode_code !== undefined &&
            drone?.status?.mode_code != 14
          ) {
            toast.update(this.toastIdDroneOn, {
              render: this.$e("Drone activé"),
              autoClose: true,
              closeOnClick: true,
              closeButton: true,
              type: "success",
              isLoading: false,
            });

            this.$root.watchVariable.remove(watcherID);
            this.openFluxVideo(true);
            this.initVerifDrcModeAllwaysActive();
          }
        },
        () => {
          toast.update(this.toastIdDroneOn, {
            render: this.$e("Erreur lors de l'activation du drone"),
            autoClose: true,
            closeOnClick: true,
            closeButton: true,
            type: "error",
            isLoading: false,
          });

          this.openFluxVideo(true);
        }
      );
    },

    initVerifDrcModeAllwaysActive() {
      this.$root.watchVariable.add(
        this.device.config,
        "dock",
        (dock, oldValue, watcherID) => {
          if (
            dock?.status?.drc_state !== undefined &&
            dock?.status?.drc_state != 2
          ) {
            API.put("drcmodeenter", {
              DevId: this.device.dev_id,
            });
          }
        }
      );
    },

    openFluxVideo(dockVideoFront = false) {
      var videos = [];
      var haveFront = false;
      /** PUBLISH  */
      this.device.config.videos.forEach((video) => {
        if (!video.publish && !video.isWebcam) {
          this.device.config.methods.ToggleVideo(this.device.config, video);
        }

        if (!video.isWebcam) {
          videos.push(video);

          if (
            !haveFront &&
            !video.cameradock &&
            !dockVideoFront &&
            !$root.isMilestonePlugin
          ) {
            this.VIDEO_EMPLACEMENT[video.dvv_id] = `#FRONT`;
            this.video_selected = video;
            haveFront = true;
          } else {
            this.VIDEO_EMPLACEMENT[video.dvv_id] = `#OVERLAY_VIDEO`;
          }
        }
      });

      /** VIDEOS */
      if (!haveFront) {
        this.device.config.videos.forEach((video) => {
          if (
            !video.isWebcam &&
            video.cameradock &&
            !haveFront &&
            !$root.isMilestonePlugin
          ) {
            this.VIDEO_EMPLACEMENT[video.dvv_id] = `#FRONT`;
            this.video_selected = video;
            haveFront = true;
          }
        });
      }
      this.videos = videos;
    },

    initSite(sit_id) {
      this.$root.setSite(sit_id);
    },

    SwitchFront(isMapFront, video_id) {
      this.video_selected = false;
      this.$root.Map_ShowOverlayElement = isMapFront;

      if (isMapFront) {
        let keys = Object.keys(this.VIDEO_EMPLACEMENT);

        keys.forEach((key) => {
          this.VIDEO_EMPLACEMENT[key] = "#OVERLAY_VIDEO";
        });

        this.MAP_EMPLACEMENT = "#FRONT";
        this.$root.positionMap = CesiumPosition.Main;
      } else {
        this.MAP_EMPLACEMENT = "#OVERLAY_MAP";
        let keys = Object.keys(this.VIDEO_EMPLACEMENT);

        keys.forEach((key) => {
          if (video_id == key) {
            this.VIDEO_EMPLACEMENT[key] = "#FRONT";

            this.videos.forEach((video) => {
              if (video.dvv_id == video_id) {
                this.video_selected = video;
              }
            });
          } else {
            this.VIDEO_EMPLACEMENT[key] = "#OVERLAY_VIDEO";
          }
        });
      }
    },

    videoOn(video) {
      video.relaod = true;
      API.put("videoon", {
        DvvId: video.dvv_id,
      });

      this.$root.watchVariable.add(
        this.device.config,
        "videos",
        (videos, oldValue, watcherID) => {
          videos.forEach((video) => {
            if (video.dvv_id == video.dvv_id && video.publish) {
              video.relaod = false;
              this.$root.watchVariable.remove(watcherID);
            }
          });
        }
      );
    },

    forceAffichage(type) {
      if ($root.isMilestonePlugin) {
        return;
      }

      if (type == "map") {
        this.SwitchFront(true);
      } else if (type == "payload") {
        this.device.config.videos.forEach((video) => {
          if (video.dvv_text == "Nacelle") {
            this.SwitchFront(false, video.dvv_id);
          }
        });
      }
    },
  },

  watch: {
    "$route.name": {
      handler: function (val) {
        if (val == "APP_POPUP" || val == "APP_POPUP_MILESTONE") {
          this.initAPP();
        }
      },
      immediate: true,
    },
  },

  computed: {
    AppClass() {
      if (this.FullScreenPage) {
        return "w-full";
      }

      if (!this.main_active) {
        return "min-w-[0px] max-w-[0px] opacity-0";
      }

      if (this.$root.appClassSurcharge != "") {
        return this.$root.appClassSurcharge;
      }

      return ENV.BASE_AppClass;
    },
  },
};
</script>
